// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://backend-2o7f.onrender.com/",
});

export default axiosInstance;

// export const weburl = "https://backend-2o7f.onrender.com/";
export const weburl = "https://backend-2o7f.onrender.com/";

export const shopurl = "https:///admin.ynbhealthcare.com/";
export const mainurl = "http://ynbhealthcare.com/";
export const fronturl = "http://admin.ynbhealthcare.com/";
export const socketURL = "https://backend-2o7f.onrender.com/";

export const keyLogin = process.env.REACT_APP_LOGIN_KEY;